<template>
  <div class="box">
    <h5 class="title">章节列表</h5>
    <ul>
      <li
        v-for="(item, index) in catalogObj"
        :key="index"
        @click="active(item, index)"
        :class="[index == activeIndex ? 'active' : '', 'vux-1px-b']"
      >
        <span class="name">{{ item.chapterName }}</span>
        <span class="time">
          {{ item.videoTime == null ? 0 : item.videoTime }}min
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: '',
  props: {
    catalogObj: {
      type: Array,
      default: function() {
        return [
          //              {
          //                name: '1.  STEMI患者规范化二级预防第二节',
          //                hourLong: "43'20''",
          //                courseId: '1',
          //                fullVideoUrl: ''
          //              }
        ];
      }
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  methods: {
    ...mapActions(['courseVideUrl']),
    active(item, index) {
      this.activeIndex = index;
      this.courseVideUrl(item.videoUrl);
      setTimeout(() => {
        document.querySelector('#ele_video').play();
      }, 500);
    }
  },
  watch: {
    catalogObj(v) {
      try {
        this.courseVideUrl(v[0].videoUrl);
      } catch (e) {
        console.error('没有章节catalog');
      }
    }
  },
  computed: {},
  components: {},
  created() {}
};
</script>
<style lang="less" scoped>
@import '../../../public/style/g.less';

.box {
  margin-top: 0.56rem;
  .title {
    font-size: 0.4rem;
  }
  ul {
    li {
      font-size: 0.3733rem;
      padding-top: 0.266rem;
      .borderPadding(0.266rem);
      .time {
        float: right;
      }
      .name {
        display: inline-block;
        width: 7.5rem;
        .textLimit();
      }
    }
    .active {
      * {
        color: #027cfa;
      }
    }
  }
}
</style>
